<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>I would like to dedicate this text to all my former students and colleagues but in particular to Mr Leon Maclaren, former leader of the School of Economic Science in London and also to Benjamin Crème, former chief editor of Share International in London and spokesperson for the return of Maitreya and The Second Coming.</p><br/>
<p style="text-indent: 00em !important;">On a more personal level, I have to mention my niece, Annette McCrory (née Foster), Julie Perigo and her husband Dan Dumitrescu, who reside in Barcelona, Elena Airini Alexandru, Antonio Fernandez-Luna Pont – my mentor in all things to do with modern Spanish and with life in today’s Spain and Colin Clarke—who, as far as I know, is the only person to have read almost everything I have written and the creator of the novel’s front-cover. All are enlightened beings and have become my best of friends over many years.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?11118b1e